import {GeneratorSentence, GeneratorSentences, SentenceGroup, SentenceGroupsByAnalysisType} from "./generator-sentences.component";

export function groupGeneratorSentencesByKey(source: GeneratorSentences): SentenceGroupsByAnalysisType {
  return {
    cas: groupByKey(source.sentences.filter(sentence => sentence.externalAnalysisType === "CAS")),
    cardiologs: groupByKey(source.sentences.filter(sentence => sentence.externalAnalysisType === "CARDIOLOGS")),
  };
}

function groupByKey(sentences: GeneratorSentence[]): SentenceGroup[] {
  const sentencesByKey = new Map<string, GeneratorSentence[]>();

  sentences.forEach(sentence => {
    sentencesByKey.set(sentence.key, sentences.filter(s => s.key === sentence.key));
  });

  return Array.from(sentencesByKey).map(([key, sentencesForKey]) => ({
    key: key,
    sentencesByLanguage: Object.fromEntries(sentencesForKey.map(s => [s.language, s.sentence])),
  }))
    .sort((a, b) => a.key.localeCompare(b.key));
}
